module.exports = __webpack_public_path__ + "static/media/pass.86ff50fc.svg";